import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankar() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Urbania Hire',
        heading: 'Urbania on rent in pune: Pune to Bhimashankar Urbania Hire',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Bhimashankar Urbania Hire services for pilgrims, families, corporate groups, and tourists planning a comfortable spiritual journey to Bhimashankar. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for Jyotirlinga darshan, group pilgrimages, sightseeing, and outstation travel from Pune. With professional chauffeurs experienced on ghat and temple routes, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to Bhimashankar Urbania hire.',

        top: 'Top Places to Visit in Bhimashankar with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and one of the most revered pilgrimage sites in Maharashtra. Nestled deep in the Sahyadri ranges, the temple is surrounded by dense forests and misty hills. Built in traditional Nagara-style architecture with intricate stone carvings, it holds immense spiritual significance. The temple is especially crowded during Mahashivratri and Shravan month, when devotees from across the country come to seek blessings and experience the powerful divine energy."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary is a rich biodiversity hotspot spread across the Western Ghats. It is home to rare and endangered species such as the Indian Giant Squirrel (Shekru), leopards, deer, and a wide variety of birds and reptiles. The sanctuary offers nature trails, trekking routes, and scenic forest landscapes, making it a paradise for wildlife enthusiasts, photographers, and eco-tourists."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a sacred hidden shrine located deep within the forest, believed to be the place where Lord Shiva manifested after defeating the demon Tripurasura. Reaching this site requires trekking through lush greenery and rocky terrain, adding an adventurous element to the spiritual journey. The quiet surroundings and natural water streams create a deeply meditative and peaceful experience."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a serene waterbody located near the Bhimashankar Temple complex. Surrounded by forests and hills, it serves as a peaceful resting spot for pilgrims and tourists. The calm waters reflect the greenery around, making it ideal for relaxation, photography, and quiet contemplation after temple darshan."
  },
  {
    "title": "Nagphani Point",
    "description": "Nagphani Point is a scenic viewpoint offering panoramic views of the Sahyadri mountain ranges and surrounding valleys. Named after its cobra-hood-shaped rock formation, the point is a favorite among trekkers and nature lovers. The mist-covered hills, cool breeze, and breathtaking landscapes make it a perfect spot for sunrise and monsoon visits."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point is a popular viewpoint from where, on a clear day, one can get distant views in the direction of Mumbai. The point offers dramatic valley views, dense forests, and floating clouds during monsoon. It is an excellent location for photography and enjoying the raw beauty of the Western Ghats."
  },
  {
    "title": "Gupt Bhimashankar Waterfall",
    "description": "Located near the Gupt Bhimashankar area, this seasonal waterfall comes alive during the monsoon months. Surrounded by thick forest and rocky cliffs, the waterfall creates a refreshing and soothing atmosphere. Visitors enjoy the sound of cascading water and the cool mist, making it a hidden natural gem in the region."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "The Bhimashankar region offers several trekking routes through the Sahyadri mountains, ranging from easy forest walks to challenging climbs. These trails pass through dense jungle, streams, and hill ridges, offering breathtaking views and close encounters with nature. Trekking here is especially popular during monsoon and winter seasons."
  },
  {
    "title": "Bhorgiri Village",
    "description": "Bhorgiri is a nearby village known for its ancient Bhimashankar caves and traditional rural lifestyle. The village provides insight into local culture, simple living, and agricultural practices of the region. It also serves as a base for trekkers and pilgrims exploring Bhimashankar and surrounding areas."
  },
  {
    "title": "Origin of River Bhima",
    "description": "Bhimashankar is believed to be the origin point of the sacred Bhima River, which flows through Maharashtra and Karnataka. The river holds immense religious importance, and devotees consider its waters holy. Visiting the river’s origin adds a deeper spiritual meaning to the Bhimashankar pilgrimage."
  }
],




"services": [
{
"name": "Pune to Bhimashankar Urbania Hire",
"description": "Pune to Bhimashankar Urbania Hire offers comfortable and dependable Urbania buses for devotees traveling to the sacred Bhimashankar temple. The service ensures a smooth hill-route journey with spacious seating, clean interiors, ample luggage space, and experienced drivers familiar with the terrain."
},
{
"name": "Bhimashankar Urbania on Rent from Pune",
"description": "Bhimashankar Urbania on Rent from Pune provides flexible Urbania bus rental options for one-day or overnight darshan trips. Ideal for families and groups, the service focuses on safety, punctual travel, and a peaceful pilgrimage experience."
},
{
"name": "Urbania Bus Rental Pune to Bhimashankar",
"description": "Urbania Bus Rental Pune to Bhimashankar offers well-maintained buses suitable for ghat roads and long travel hours. With professional chauffeurs and comfortable seating, it ensures a relaxed and secure journey from Pune."
},
{
"name": "Urbania AC Bus Bhimashankar Tour",
"description": "Urbania AC Bus Bhimashankar Tour provides fully air-conditioned Urbania buses for a comfortable and climate-controlled ride, making the journey pleasant for senior citizens, families, and group travelers."
},
{
"name": "Family Bhimashankar Darshan Urbania Pune",
"description": "Family Bhimashankar Darshan Urbania Pune is designed to offer safe, spacious, and comfortable travel for families, ensuring an enjoyable and stress-free darshan experience for all age groups."
},
{
"name": "Corporate Bhimashankar Tour Urbania Pune",
"description": "Corporate Bhimashankar Tour Urbania Pune offers organized transportation solutions for corporate groups planning spiritual or team tours, with punctual schedules and professional drivers."
},
{
"name": "Luxury Urbania Bhimashankar Tour",
"description": "Luxury Urbania Bhimashankar Tour delivers a premium travel experience with modern interiors, plush seating, and superior ride comfort, ideal for travelers seeking a refined pilgrimage journey."
},
{
"name": "Affordable Bhimashankar Darshan Urbania Pune",
"description": "Affordable Bhimashankar Darshan Urbania Pune provides budget-friendly Urbania bus rental services without compromising on safety, comfort, or reliability, making it suitable for group devotees."
},
{
"name": "Chauffeur Driven Urbania Bhimashankar Yatra",
"description": "Chauffeur Driven Urbania Bhimashankar Yatra ensures a stress-free pilgrimage with trained, verified drivers experienced in mountain and temple routes."
},
{
"name": "Best Bhimashankar Urbania Package Pune",
"description": "Best Bhimashankar Urbania Package Pune offers complete darshan travel solutions with comfortable buses, reliable service, and well-planned itineraries for devotees."
},
{
"name": "Group Travel Bhimashankar Urbania",
"description": "Group Travel Bhimashankar Urbania provides spacious and coordinated transportation for large groups, allowing everyone to travel together comfortably and safely."
},
{
"name": "Pilgrimage Urbania Hire Pune",
"description": "Pilgrimage Urbania Hire Pune specializes in religious tours, offering clean buses, courteous drivers, and well-organized travel plans for temple visits."
},
{
"name": "Pune Bhimashankar Darshan Bus Booking",
"description": "Pune Bhimashankar Darshan Bus Booking allows easy and hassle-free booking of Urbania buses, ensuring smooth coordination, timely departures, and a comfortable darshan trip."
},
{
"name": "Trusted Bhimashankar Urbania Service",
"description": "Trusted Bhimashankar Urbania Service is known for dependable operations, customer satisfaction, and safe travel standards, making it a reliable choice for Bhimashankar temple tours."
},
{
"name": "Temple Tour Urbania Pune",
"description": "Temple Tour Urbania Pune offers dedicated Urbania buses for temple and religious tours from Pune, ensuring a peaceful, comfortable, and spiritually enriching travel experience."
}
],
"tableData": [
["Pune to Bhimashankar Urbania Hire", "Bhimashankar Urbania on Rent from Pune"],
["Urbania Bus Rental Pune to Bhimashankar", "Urbania AC Bus Bhimashankar Tour"],
["Family Bhimashankar Darshan Urbania Pune", "Corporate Bhimashankar Tour Urbania Pune"],
["Luxury Urbania Bhimashankar Tour", "Affordable Bhimashankar Darshan Urbania Pune"],
["Chauffeur Driven Urbania Bhimashankar Yatra", "Best Bhimashankar Urbania Package Pune"],
["Group Travel Bhimashankar Urbania", "Pilgrimage Urbania Hire Pune"],
["Pune Bhimashankar Darshan Bus Booking", "Trusted Bhimashankar Urbania Service"],
["Temple Tour Urbania Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Bhimashankar Urbania Hire for Comfortable Pilgrimage",
        "WhyChoosedescription": "Pune to Bhimashankar Urbania Hire is ideal for devotees, families, and groups planning a peaceful and comfortable pilgrimage to the sacred Bhimashankar temple."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Bhimashankar travel are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for a smooth journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Hill and Temple Routes",
        "WhyChoosedescription": "All drivers are trained and experienced in handling ghat roads and the Pune to Bhimashankar route, ensuring safe and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Bhimashankar Urbania Hire offers competitive pricing with no hidden charges, making your pilgrimage economical and worry-free."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and travel planning."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for same-day trips, one-day returns, group pilgrimages, family tours, and customized travel schedules."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Bhimashankar Urbania Hire service ensures on-time pickups, smooth travel, and dependable service throughout the journey."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Bhimashankar Urbania Hire be booked for group travel?',
        answer: 'Yes, it is perfect for group pilgrimages, family trips, senior citizen tours, and devotional travel.'
    },
    {
        question: 'How can I book Pune to Bhimashankar Urbania Hire?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Bhimashankar Urbania Hire?',
        answer: 'This service offers comfortable seating, experienced drivers, clean vehicles, flexible travel options, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with the Bhimashankar route?',
        answer: 'Yes, all drivers are trained and familiar with the Pune to Bhimashankar route including ghat sections.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Bhimashankar Urbania Hire available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety and comfort.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and senior citizens?',
        answer: 'Yes, Pune to Bhimashankar Urbania Hire is ideal for families, senior citizens, and devotional groups.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sanjay Kulkarni',
        feedback: 'Our Pune to Bhimashankar trip was very comfortable. The Urbania bus handled the ghat roads smoothly and the journey was peaceful.',
        rating: 5
    },
    {
        id: 2,
        name: 'Mrs. Meena Deshpande',
        feedback: 'Excellent service for Bhimashankar darshan. Clean bus, experienced driver, and punctual service. Highly recommended.',
        rating: 5
    }
];









































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Urbania Hire",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-bhimashankar-urbania.jpg",
  "description": "Pune to Bhimashankar Urbania Hire offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Bhimashankar.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-bhimashankar-urbania-hire"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Bhimashankar Urbania Hire | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Bhimashankar Urbania Hire for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Bhimashankar."
  />

  <meta
    name="keywords"
    content="Pune to Bhimashankar Urbania Hire, Bhimashankar Urbania on Rent from Pune, Urbania Bus Rental Pune to Bhimashankar, Urbania AC Bus Bhimashankar Tour, Family Bhimashankar Darshan Urbania Pune, Corporate Bhimashankar Tour Urbania Pune, Luxury Urbania Bhimashankar Tour, Affordable Bhimashankar Darshan Urbania Pune, Chauffeur Driven Urbania Bhimashankar Yatra, Best Bhimashankar Urbania Package Pune, Group Travel Bhimashankar Urbania, Pilgrimage Urbania Hire Pune, Pune Bhimashankar Darshan Bus Booking, Trusted Bhimashankar Urbania Service, Temple Tour Urbania Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/87.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankar;